/* Copyright (c)2023 Sky Co., LTD. All rights reserved. */

/*Trunk\SaaS\Web\CtlSvr_Cloud\CtlSvr_Cloud\Models\Packet\PacketDefine.cs*/
export class PacketDefine {
    public readonly  REV_11_1 = 21;         // Ver.11.1
    public readonly  REV_13_2 = 47;         // Ver.13.2
    public readonly  REV_17_0_1 = 130;      // Ver.17.0
    public readonly  REV_17_2 = 140;        // Ver.17.2
    public readonly  REV_17_204 = 143;      // Ver.17.204
    public readonly  REV_17_2_2 = 152;      // Ver.17.22
    public readonly  REV_18_0 = 156;        // Ver.18.0
    public readonly  REV_18_0_1 = 163;      // Ver.18.01
    public readonly  REV_18_1 = 166;        // Ver.18.1
    public readonly  REV_18_2 = 170;        // Ver.18.2
    public readonly  REV_18_2_0_1 = 173;    // Ver.18.201
    public readonly  REV_18_2_2 = 179;      // Ver.18.22
    public readonly  REV_19_0 = 184;        // Ver.19.0
    public readonly  REV_19_0_0_MDM_01 = 186; // Ver.19.0（社内MDM乗り換え1回目）
    public readonly  REV_19_1_0 = 189;      // Ver.19.1
}

/* Copyright (c)2023 Sky Co., LTD. All rights reserved. */
